<template>
  <page-container class="advertisement-list"
    :title="$t('通知公告')" :loading="loading" :empty="!advertisements.length">
    <van-cell v-for="item of advertisements" :key="item.id"
      :title="item.title" :label="item.text.slice(0, 64) + '...'" is-link
      @click="() => go2advertisement(item)" />
  </page-container>
</template>

<script>
import localforage from 'localforage'
import { Cell } from 'vant'
import PageContainer from '../../components/PageContainer'
import { LF_KEYS } from '../../constants'

export default {
  components: {
    PageContainer,
    'van-cell': Cell
  },
  name: 'advertisement-list',
  data () {
    return {
      loading: false,
      advertisements: []
    }
  },
  methods: {
    getAdvertisement () {
      this.$apis.home.getAdvertisement(
        loading => (this.loading = loading)
      ).then(res => {
        if (res) {
          this.advertisements = res
          localforage.setItem(LF_KEYS.ADVERTISEMENTS, res)
        }
      })
    },
    go2advertisement (item) {
      this.$router.push({
        name: 'advertisement',
        query: { id: item.id },
        params: { stackType: 'push' }
      })
    }
  },
  mounted () {
    this.getAdvertisement()
  }
}
</script>
